import {endpoints} from './endpoints'
import request from '../helpers/request'

export function customPushNotificationToUsers(data){
	return new Promise((resolve, reject) => {
    request({
      url: endpoints.customPushNotificationToUsers,
      method: 'post',
      data
    })
		  .then(function (response) {
				console.log(response)
		    resolve(response)
		  })
		  .catch(function (error) {
		    reject(error)
		  });
	})
}